import React, { useContext, useState, useEffect, useRef } from 'react';
import { withStyles, makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";

const useStyles = makeStyles(theme => ({
    root: {
        margin: 10,
        flexGrow: 1,
    },
    cursorPointer: {
        cursor: 'pointer',
    },
}));
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const CofirmationDialogBox = (props) =>{
    const classes = useStyles();
    return (
        <>
            <div>
                <Dialog
                    open={props.open}
                    onClose={props.onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {props.message}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onYesClick} color="primary">
                            Yes</Button>
                        <Button
                            onClick={props.onNoClick}
                            color="primary"
                            autoFocus>No
                        </Button>
                    </DialogActions>
                </Dialog></div>
        </>)
}
export default CofirmationDialogBox;
